export default "__VITE_ASSET__CiLoURSl__"